import { twMerge } from "tailwind-merge";

export function ChatTipsSvg({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 994 74"
      preserveAspectRatio="none"
      className={twMerge("pointer-events-none", className)}
    >
      <path
        d="M32.25 0.25H964.95C970.949 0.25 975.449 0.250889 978.975 0.632812C982.5 1.01479 985.052 1.77785 987.155 3.30566C988.513 4.29237 989.708 5.48674 990.694 6.84473C992.222 8.94758 992.985 11.5 993.367 15.0254C993.749 18.5508 993.75 23.0506 993.75 29.0498L993.743 73H0.498047L0.25 32.5254V32.25C0.25 26.6496 0.249995 22.4493 0.522461 19.1143C0.794946 15.7792 1.33976 13.309 2.42969 11.1699C4.34714 7.40679 7.40679 4.34714 11.1699 2.42969C13.309 1.33976 15.7792 0.794946 19.1143 0.522461C22.4493 0.249995 26.6496 0.25 32.25 0.25Z"
        fill="url(#paint0_linear_5758_1150)"
        stroke="url(#paint1_linear_5758_1150)"
        strokeWidth="0.5"
      />
      <path
        opacity="0.56"
        d="M964.95 0C970.944 -7.25152e-09 975.46 2.94745e-05 979.002 0.383789C982.549 0.76807 985.149 1.53957 987.302 3.10352C988.681 4.10574 989.894 5.31884 990.896 6.69824C992.46 8.85083 993.232 11.4514 993.616 14.998C994 18.5401 994 23.0559 994 29.0498V32.5H993.75V32.25C993.75 32.4965 993.739 73.25 993.732 73.25L37 73.25C12.7979 73.25 12 73.25 0.25 73.25L0 32.5L0 32.25C0 26.6536 -6.61314e-05 22.4413 0.273438 19.0938C0.547184 15.7432 1.09615 13.2369 2.20703 11.0566C4.14847 7.24636 7.24636 4.14847 11.0566 2.20703C13.2369 1.09615 15.7432 0.547184 19.0938 0.273438C22.4413 -6.61016e-05 26.6536 0 32.25 0H964.95Z"
        fill="url(#paint2_linear_5758_1150)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5758_1150"
          x1="0"
          y1="36.625"
          x2="994"
          y2="36.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5758_1150"
          x1="1.28116e-06"
          y1="-33.8075"
          x2="592.904"
          y2="113.657"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9357" />
          <stop offset="0.5" stopColor="#7934E6" />
          <stop offset="1" stopColor="#324AFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5758_1150"
          x1="0"
          y1="0"
          x2="663.258"
          y2="357.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9357" />
          <stop offset="0.5" stopColor="#7934E6" />
          <stop offset="1" stopColor="#324AFF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
